import { formatDuration } from '@vgtv/time-helpers';
import { FunctionComponent } from 'preact';
import { useCallback, useState } from 'preact/hooks';

import { useJWPlayerEvent } from '../../hooks/useJWPlayerEvent';
import { Typography, TypographyProps } from '../Typography/Typography';
import { useTranslation } from '../../../../utils/useTranslation';
import ns from '../../translations';

export const AdTimeDisplay: FunctionComponent<{
  color?: TypographyProps['color'];
}> = ({ color = 'white' }) => {
  const [remaining, setRemaining] = useState('');
  const { t } = useTranslation(ns);

  const handleTime = useCallback((param: jwplayer.AdTimeParam) => {
    const timeLeft = Math.max(0, param.duration - param.position);
    setRemaining(formatDuration(timeLeft * 1000));
  }, []);

  useJWPlayerEvent('adTime', handleTime);

  return (
    <div className="vgp-time-display">
      <Typography color={color} variant="label" size="small">
        {t('advertisement')} ({remaining})
      </Typography>
    </div>
  );
};
